import type { NotificationSeed } from '@/types';

/**
 * Demo notification log for the signed-in laundry only (FB09).
 * Order-linked notifications reference real orders from src/mocks/orders.ts and
 * review-linked ones reference real reviews from src/mocks/reviews.ts, so the
 * notification never contradicts the other pages.
 *
 * Times are stored as "minutes ago" so they are ALWAYS in the past and always
 * after the moment the related element was created — the service turns them into
 * real dates at load time. Replaced by the notifications API later.
 *
 * Covers: a still-pending new order, a new-order notification whose order moved
 * on, a driver hand-off confirmation, an escalation that still needs assignment,
 * an escalation that ended, a fresh review, and a driver review.
 */
export const mockNotificationSeeds: NotificationSeed[] = [
  {
    id: 'NTF-9007',
    kind: 'new_review',
    createdMinutesAgo: 40,
    reviewId: 'RV-6001',
  },
  {
    id: 'NTF-9001',
    kind: 'new_order',
    createdMinutesAgo: 240,
    orderId: 'LB-1042',
  },
  {
    id: 'NTF-9004',
    kind: 'manual_assignment',
    createdMinutesAgo: 260,
    orderId: 'LB-1035',
  },
  {
    id: 'NTF-9002',
    kind: 'new_order',
    createdMinutesAgo: 300,
    orderId: 'LB-1039',
  },
  {
    id: 'NTF-9003',
    kind: 'order_handoff',
    createdMinutesAgo: 420,
    orderId: 'LB-1036',
  },
  {
    id: 'NTF-9006',
    kind: 'new_review',
    createdMinutesAgo: 1490,
    reviewId: 'RV-5002',
  },
  {
    id: 'NTF-9005',
    kind: 'manual_assignment',
    createdMinutesAgo: 1560,
    orderId: 'LB-1027',
  },
  {
    id: 'NTF-9009',
    kind: 'order_handoff',
    createdMinutesAgo: 2880,
    // Historical notification whose order is no longer reachable — exercises the
    // "linked item unreachable" state without inventing any order data.
    orderId: 'LB-0999',
  },
];